import React from 'react';
import OptimizedWorkspace from './components/OptimizedWorkspace';

function App() {
  return (
    <div className="App">
      <OptimizedWorkspace />
    </div>
  );
}

export default App; 